//Match Action types
export const GET_MATCHES = "GET_MATCHES";
export const SET_MATCH_LIST = "SET_MATCH_LIST";
export const GET_MATCHES_FAILURE = "GET_MATCHES_FAILURE";
export const GET_MATCHES_SUCCESS = "GET_MATCHES_SUCCESS";
export const SET_SELECTED_MATCH = "SET_SELECTED_MATCH";
